import EditablePropsType from '../../../types/composer';
import mediaSchema from './media';
import { ctasSchema } from './cta';
import headingSchema from './heading';
import subheadingSchema from './subheading';
import textSchema from './text';

export const mediaListSchema = {
  type: EditablePropsType.Array,
  label: 'List',
  name: 'list',
  items: {
    type: EditablePropsType.Object,
    properties: {
      media: {
        ...mediaSchema,
        properties: {
          ...mediaSchema.properties,
          alignment: {
            ...mediaSchema.properties.alignment,
            selectOptions: {
              options: [
                {
                  value: 'right',
                  label: 'Right',
                },
                {
                  value: 'left',
                  label: 'Left',
                },
              ],
            },
          },
        },
      },
      heading: headingSchema,
      subheading: subheadingSchema,
      text: textSchema,
      ctas: ctasSchema,
    },
  },
};

export default mediaListSchema;
